import {useState} from "react";
import StoreForm from "./StoreForm"

const PopupWindow = ( { isOpen, purchaseData, closePopUp, ethereumButton, address, ethereumProvider, buyHandle } ) => {
    return (
        <div className={`fixed inset-0 flex items-center justify-center z-50 ${isOpen ? '' : 'hidden'}`}>
            <div className="bg-white p-6 w-1/4 rounded shadow-lg">
                <h3 className="text-lg font-semibold mb-4 text-center">Purchase Resume</h3>
                <p className="text-justify">Your are purchasing a <b>{purchaseData.duration}</b> license for <b>{purchaseData.name}</b>, for
                    the price of <b>{purchaseData.price}</b>. This program is a property of <b>{purchaseData.enterprise}</b>, and
                    by continuing you are subject to their terms and conditions.
                </p>
                <div className="flex min-w-20">
                    <button
                        className="p-10 flex-grow bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded mt-4"
                        onClick={closePopUp}
                    >
                        Close
                    </button>
                    <div style={{ marginLeft: '10px' }}></div>
                    {address === null ? <button
                        onClick={ethereumButton} className="p-10 flex-grow bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded mt-4"
                    >
                        Continue with MetaMask
                    </button> : <StoreForm  userAddress={address} ethereumProvider={ethereumProvider} buyHandle={buyHandle}/>}
                </div>
            </div>
        </div>
    );
};

export default PopupWindow;